import { render, staticRenderFns } from "./advertisements.vue?vue&type=template&id=4224cb4e&"
import script from "./advertisements.vue?vue&type=script&lang=js&"
export * from "./advertisements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports